import { fetcher } from '@commenda/utils';
import { TGovernmentIdentifierDocumentRequest } from './createGovernmentIdentifier';

export type UpdateGovernmentIdentifierRequest = {
  value?: string;
  /** The identifier's whole evidence: an empty list clears it, and leaving it out changes nothing. */
  supportingDocuments?: TGovernmentIdentifierDocumentRequest[];
};

export const updateGovernmentIdentifier = async (
  businessEntityId: number,
  governmentIdentifierId: string,
  body: UpdateGovernmentIdentifierRequest
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/government-identifiers/${governmentIdentifierId}`,
    { method: 'PATCH', body }
  );

  return response;
};
